import styled from 'styled-components';

export interface Props {
  animationDuration: number;
  maxHeight: number;
  minHeight: number;
}

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

export const Wrapper = styled('div')<Props>`
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  transition: height ${({ animationDuration }) => animationDuration}s
    ${cubicBezier};
  &[data-state='entering'],
  &[data-state='entered'],
  &[data-state='exiting'] {
    height: ${({ maxHeight }) => maxHeight}px;
  }
  &[data-state='exited'] {
    height: ${({ minHeight }) => minHeight}px;
  }
  &[data-state='entered'] {
    height: auto;
    overflow-y: visible;
  }
`;
